import { SessionModeEnum } from '@/enums/SessionModeEnum';

export default {
    title: 'คาบเรียน',
    buttons: {
        start: 'เริ่มคาบเรียน',
        selfStart: 'เริ่มเรียนด้วยตนเอง',
        end: ({ values }: { values: { mode: SessionModeEnum } }) => {
            const { mode } = values;
            if (mode === SessionModeEnum.SELF) return 'จบการเรียนด้วยตนเอง';
            if (mode === SessionModeEnum.TASK) return 'ปิดรับการบ้าน';
            return 'จบคาบเรียน';
        },
        exit: 'ออก',
        review: 'ตรวจดู',
        pause: 'หยุดชั่วคราว',
        resume: 'ทำต่อ',
        selfModeDoneConfirm: ({ values }: { values: { mode: SessionModeEnum } }) => {
            if (values.mode === SessionModeEnum.TASK) {
                return 'จะปิดรับการบ้านไหม?<br />หากปิดรับ นักเรียนจะไม่สามารถทำการบ้านให้เสร็จได้อีก';
            }
            return 'จะจบการเรียนด้วยตนเองไหม?<br />หากยังมีนักเรียนที่ยังไม่เสร็จ ประวัติการเรียนจนถึงตอนนี้จะถูกบันทึก';
        },
        selfDoneConfirm:
            'การเรียนด้วยตนเองยังดำเนินอยู่ จะจบแบบนี้เลยไหม?<br />แม้จบการเรียนด้วยตนเอง ประวัติการเรียนจนถึงตอนนี้ก็จะถูกบันทึก',
        selfDoneConfirmMessage: 'ทำโหมดเรียนด้วยตนเองเสร็จแล้ว!',
        taskDoneConfirmMessage: 'ทำการบ้านเสร็จแล้ว!',
        goStudentPage: 'ไปที่ห้องรอ',
        goTaskResult: 'ดูผลลัพธ์',
    },
    modal: {
        title: {
            ongoing: 'กิจกรรมกำลังดำเนินอยู่',
            completed: 'จบ{mode}',
        },
        message: {
            ongoing: 'มีกิจกรรมที่กำลังดำเนินอยู่\nกรุณาจบกิจกรรมก่อนแล้วจึงจบคาบเรียน',
            completed: 'จะจบ{mode}ไหม?',
        },
    },
    status: {
        ongoing: 'กำลังดำเนินการ',
        completed: 'เสร็จสิ้น',
        paused: 'หยุดชั่วคราว',
        preparing: 'กำลังเตรียม',
        waiting: 'กำลังรอ',
    },

    timer: {
        format: '{minutes}:{seconds}',
        started: 'เริ่มเมื่อ {time}',
        duration: 'ดำเนินการ {duration} นาที',
    },

    students: {
        online: 'ออนไลน์',
        offline: 'ออฟไลน์',
        total: 'ทั้งหมด',
        count: '{count} คน',
        countFormat: '{online}/{total}',
        selectAll: 'เลือกทั้งหมด',
        selected: 'เลือกแล้ว',
        unselected: 'ยกเลิกการเลือก',
        notSubmitted: 'นักเรียนที่ยังไม่ส่ง',
    },

    screen: {
        toggle: 'หน้าจอกระดาน',
        on: 'ON',
        off: 'OFF',
        options: {
            none: 'ไม่ใช้',
            basic: 'หน้าจอหลัก',
            waitingRoom: 'ห้องรอ',
            activity: 'หน้าจอกิจกรรม',
            sessionResult: 'หน้าจอผลคาบเรียน',
            moduleResult: 'หน้าจอผลกิจกรรม',
        },
    },

    focus: {
        toggle: 'โหมดตั้งใจเรียน',
        on: 'เปิดโหมดตั้งใจเรียน',
        off: 'ปิดโหมดตั้งใจเรียน',
    },

    star: {
        title: 'ดาวชมเชย',
        give: 'ให้ดาวชมเชย',
        comment: 'ข้อความชมเชย',
        comments: {
            great: 'ทำได้ดี!',
            excellent: 'ยอดเยี่ยม!',
            good: 'ดีมาก!',
            perfect: 'สมบูรณ์แบบ!',
            amazing: 'สุดยอด!',
        },
    },

    module: {
        start: 'เริ่มกิจกรรม',
        end: 'จบกิจกรรม',
        setting: 'ตั้งค่ากิจกรรม',
        preview: 'ดูตัวอย่าง',
        result: 'ดูผลลัพธ์',
        inProgress: 'กิจกรรมกำลังดำเนินอยู่',
        completed: 'กิจกรรมเสร็จสิ้น',
        fold: 'พับหัวข้อการเขียน',
        subject: 'หัวข้อการเขียน',
    },

    navigation: {
        home: 'ไปหน้าหลัก',
        waitingRoom: 'ไปที่ห้องรอ',
        result: 'ดูผลลัพธ์',
        next: 'กิจกรรมถัดไป',
        previous: 'กิจกรรมก่อนหน้า',
    },
};
